import React from 'react';
// Shopify CDN supports ?width=X for on-the-fly resizing
const heroBase = 'https://cdn.shopify.com/s/files/1/0963/9372/4268/files/image_21_1.webp?v=1771098855';
export function HeroImage() {
  return <section className="w-full bg-[var(--bg-darker)] py-1 md:py-2 px-4" data-id="element-173">
      <div className="max-w-4xl mx-auto" data-id="element-174">
        {/*
          LCP IMAGE — Critical optimizations:
          1. loading="eager" + fetchpriority="high" — browser prioritizes this
          2. decoding="auto" — let browser choose optimal decode strategy
          3. No shadow-xl on the img itself — shadow applied via wrapper to avoid
             delaying the image paint. The browser marks LCP when the image pixels
             are painted; box-shadow on the img element adds compositing work
             BEFORE that paint completes.
          4. Explicit width/height prevent layout shift
         */}
        <div className="rounded-lg shadow-xl overflow-hidden" data-id="element-175">
          <img src={`${heroBase}&width=700`} srcSet={`${heroBase}&width=400 400w, ${heroBase}&width=700 700w, ${heroBase}&width=900 900w`} sizes="(max-width: 640px) calc(100vw - 2rem), (max-width: 1024px) 90vw, 896px" alt="Método Jabones Artesanales" className="w-full h-auto block" loading="eager" fetchpriority="high" decoding="auto" width={896} height={504} data-id="element-176" />
        </div>

        <p className="text-center text-base md:text-xl lg:text-2xl text-[var(--text-light)] mt-4 md:mt-6 font-medium leading-relaxed" data-id="element-177">
          Método paso a paso que transforma una técnica artesanal en un negocio
          real, incluso si empiezas sin experiencia.
        </p>

        <div className="flex justify-center mt-4 md:mt-6" data-id="element-178">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[var(--accent-orange)] to-[var(--accent-orange-hover)] px-4 py-2 md:px-6 md:py-3 rounded-full shadow-lg" data-id="element-179">
            <span className="text-white text-sm md:text-base lg:text-lg font-bold" data-id="element-180">
              +2500 descargas
            </span>
          </div>
        </div>
      </div>
    </section>;
}